// extracted by mini-css-extract-plugin
export default {"root":"EditListingQuoteBusinessDetailsPannel_root__QZWWb","form":"EditListingQuoteBusinessDetailsPannel_form__svfcv","title":"EditListingQuoteBusinessDetailsPannel_title__BEqAz"};